// extracted by mini-css-extract-plugin
export default {"TooltipMessage":"_TooltipMessage--cOUej","EmptyContractMessage":"_EmptyContractMessage--xk2tP"};